import { FC, ReactElement, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useIsSignedIn from "../../hooks/useIsSignedIn";
import Header from "../../components/Header";
import { disableMessageBar } from "../redux/MessageBarSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import HelpSupport from "../../pages/HelpSupport";
import Homepage from "../../pages/Homepage";

const Layout: FC = (): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const isVisible = useAppSelector((state) => state.MessageBarView.isVisible);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => dispatch(disableMessageBar()), 2000);
    }
  }, [isVisible, dispatch]);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/home");
    }
  }, [location.pathname, navigate]);

  const isSignedIn = useIsSignedIn();

  useEffect(() => {
    // Outlook add-in deep link (/import?source=outlook&...): when the user is
    // not signed in yet, remember the full link so the login flow can return
    // here afterwards (Login navigates to the stored LINK on completion).
    if (!isSignedIn && location.pathname === "/import") {
      localStorage.setItem("LINK", window.location.href);
    }
  }, [isSignedIn, location.pathname]);
  
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
      }}
    >
      <Header />
      {!isSignedIn && location.pathname === "/support" ? (
        <HelpSupport />
      ) : !isSignedIn && location.pathname !== "/home" ? (
        // Display homepage by default if the user is attempting to access any other page without signing in
        <Homepage />
      ) : (
        <Outlet />
      )}
    </div>
  );
};

export default Layout;
